module.exports = __webpack_public_path__ + "04c64da7b63ee1587eb4a0e9410aaea7.svg";